import $ from 'jquery';
import { colors } from '../colors';
import { singleAxes, doubleAxes, value, percentage } from '../options';

class RegistedReceipts {
  constructor() {
  }

  static Chart(callback) {
    let ctx = $('#charts__registed-receipts')
    let check = $('canvas').is('#charts__registed-receipts')
    let project_id = $('[data-project-id]').data('project-id')
    let env = $('[data-env]').data('env')

    let first_week = parseUrl('start_week')
    let end_week = parseUrl('end_week')
    let days_from = parseUrl('days_from')
    let days_to = parseUrl('days_to')
    let period_filter_type = parseUrl('period_filter_type')
    let periodParams = '&period_filter_type=' + period_filter_type +
                       '&start_week=' + first_week + '&end_week=' + end_week +
                       '&days_from=' + days_from + '&days_to=' + days_to

    let datasets = []
    let options = singleAxes

    if(check) {
      $.ajax({
        url: `/api/v1/statistics/receipts_by_periods?project_id=${project_id}&env=${env}` + periodParams,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
          initChart(response)
        }
      });

      let initChart = function(response){

        let actual_dataset = {
          yAxisID: "bars",
          type: "line",
          label: "Количество валидных чеков (факт за период)",
          data: response.receipts_actual,
          backgroundColor: colors.green[300],
          hoverBackgroundColor: colors.green[500],
          borderColor: colors.green[500],
          hoverBorderColor: colors.green[500],
          fill: false,
          datalabels: value
        }

        datasets.push(actual_dataset)

        if (response.receipts_plan){
          let plan_datasets = [
            {
              yAxisID: "bars",
              type: "line",
              label: "Количество валидных чеков (план за период)",
              data: response.receipts_plan,
              backgroundColor: colors.violet[300],
              hoverBackgroundColor: colors.violet[500],
              borderColor: colors.violet[500],
              hoverBorderColor: colors.violet[500],
              fill: false,
              datalabels: value
            },
            {
              yAxisID: "lines",
              type: "scatter",
              label: "Процент от плана",
              data: response.plan_percentage,
              backgroundColor: colors.orange[300],
              hoverBackgroundColor: colors.orange[500],
              borderColor: colors.orange[500],
              hoverBorderColor: colors.orange[500],
              pointBackgroundColor: colors.orange[300],
              hoverPointBackgroundColor: colors.orange[500],
              pointBorderColor: colors.orange[500],
              hoverPointBorderColor: colors.orange[500],
              showLine: false,
              fill: false,
              datalabels: percentage
            }
          ]
          $.merge(datasets, plan_datasets)
          var maxTicks = Math.max(...response.plan_percentage) / 100
          maxTicks = Math.ceil(maxTicks) * 100;
          var yAxesOptions = Object.assign({}, doubleAxes)
          yAxesOptions['scales']['yAxes'][1]['ticks']['max'] = maxTicks
          options = yAxesOptions
        }

        let animationOptions = {
          animation: {
            onComplete: function(){
              if (typeof callback == "function") {
                callback(newChart.toBase64Image());
              }
            }
          }
        }

        let newChart = new Chart(ctx, {
          type: "bar",
          data: {
            labels: response.labels,
            datasets: datasets
          },
          options: { ...options, ...animationOptions }
        });

        let showValue = true
        let newValueOptions = {}

        $('#registed-receipts-switch').on('click', function(){
          $(this).toggleClass('on')

          if(showValue == true)
          {
            showValue = false
            newValueOptions = {}
          }
          else
          {
            showValue = true
            newValueOptions = value
          }

          datasets.forEach(function(dataset) {
            dataset['datalabels'] = newValueOptions
          })

          newChart.update()
        })
      }
    }
  }

  static onInit() {
    RegistedReceipts.Chart();
  }
}

export default RegistedReceipts;
